import Colunas from './static_data/colunasAcessorios';
import ColunasFilterTags from './static_data/colunasFilterTagsAcessorios';

export default {
    statusAcessorios: "Todos",
    escolhaSituacaoAcessorios: 0,

    searchFieldAcessorios: "",
    searchFieldExternalAcessorios: "",

    rowsPerPageAcessorios: 2,
    totalRowsAcessorios: 0,
    pageFrom: 0,

    dataAcessorios: [],
    dataAcessoriosSelected: [],
    opcoesGrupos: [],
    opcoesFamilias: [],
    escolhaGrupo: 0,
    escolhaFamilia: 0,
    isSelectFamiliasAcessoriosDisabled: true,


    colunasAcessorios: Colunas,
    colunasFilterTagsAcessorios: ColunasFilterTags,
};